<div class="card mb-4 card-hover py-5 px-5 d-none d-md-block d-lg-block" style="border-radius: 50px;" *ngIf="username!=null">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-8">
          <h5 class="p-5">
            {{'touchconnect_profile_live' | translate}}<a href="/{{username}}" target="_blank" class="tex-dark">{{username}}</a><br>
          </h5>
        </div>
        <div class="col-lg-4">
          <a class="btn btn-primary  rounded-4 mt-4 shadow" href="/{{username}}" target="_blank">
            {{'profile_live' | translate}}
           </a>
        </div>
      </div>
    </div>
  </div>

  <div class="card mb-4 text-center py-3 d-block d-md-none d-lg-none" style="border-radius: 50px;" *ngIf="username!=null">
  
      <h5 class="p-3">
       {{'touchconnect_profile_live' | translate}}
      </h5>
       <a class="btn btn-primary  rounded-4 shadow" href="/{{username}}" target="_blank">
        {{'profile_live' | translate}}
       </a>
    
  </div>